<!-- 柱状图 -->
<template>
    <div class="titleText">
        <div class = 'row'>
            <p class = 'title'>标题显示</p>
            <el-switch v-model="baseConfig.title.textShow" @change = 'handleclickblur' />
          </div>
          <div class = 'row'>
            <p class = 'title'>标题高度</p>
            <p class = 'setvalue'>
              <el-input v-model="baseConfig.title.Height" @blur="handleclickblur"  placeholder="请输入标题高度" />
            </p>
          </div>
          <div class = 'row'>
            <p class = 'title'>标题名称</p>
            <p class = 'setvalue'>
              <el-input v-model="baseConfig.title.textTitle" @blur="handleclickblur"   placeholder="请输入标题名称"  />
            </p>
          </div>
          <div class = 'row'>
            <p class = 'title'>字体颜色</p>
            <p class = 'setvalue'>
              <el-input
                v-model="baseConfig.title.textColor"
                style="max-width: 600px"
                placeholder="Please input"
                @blur="handleclickblur"
               >
              <template #append><el-color-picker @change="handleclickblur" v-model="baseConfig.title.textColor" show-alpha /> </template>
             </el-input>
            </p>
          </div>
          <div class = 'row'>
            <p class = 'title'>字体字号</p>
            <p class = 'setvalue'>
              <el-input-number
                v-model="baseConfig.title.textSzie"
                controls-position="right"
                @change="handleclickblur"
              />
            </p>
          </div>
          <div class = 'row'>
            <p class = 'title'>字体对齐方式</p>
            <p class = 'setvalue'>
                <el-select
                v-model="baseConfig.title.textAlign"
                placeholder="请输入字体对齐方式"                
                style="max-width: 600px"
                @change="handleclickblur"
                >
                <el-option
                    v-for="item in optionxy"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                />
                </el-select>
            </p>
          </div>
          <div class = 'row'>
            <p class = 'title'>左侧小图标</p>
            <p class = 'setvalue'>
                <avatarUpload 
                :imageUrl='baseConfig.title.textIcon' 
                @getImageData="(val)=>{return getImageData(val,'textIcon')}" 
                @delImageData="delImageData('textIcon')" urlName="textIcon">
              </avatarUpload>
            </p>
          </div>
          <div class = 'row'>
            <p class = 'title'>小图标宽度</p>
            <p class = 'setvalue'>
                <el-input-number
                v-model="baseConfig.title.textWidth"
                controls-position="right"
                @change="handleclickblur"
              />
            </p>
          </div>
          <div class = 'row'>
            <p class = 'title'>小图标高度</p>
            <p class = 'setvalue'>
              <el-input-number
                v-model="baseConfig.title.textHeight"
                controls-position="right"
                @change="handleclickblur"
              />
            </p>
          </div>
          <div class = 'row'>
            <p class = 'title'>小图标左间距</p>
            <p class = 'setvalue'>
              <el-input-number
                v-model="baseConfig.title.textLeft"
                controls-position="right"
                @change="handleclickblur"
              />
            </p>
          </div>
          <div class = 'row'>
            <p class = 'title'>小图标右间距</p>
            <p class = 'setvalue'>
              <el-input-number
                v-model="baseConfig.title.textRight"
                controls-position="right"
                @change="handleclickblur"
              />
            </p>
          </div>
          <div class = 'row'>
            <p class = 'title'>标题背景图片</p>
            <p class = 'setvalue'>
                <avatarUpload 
                :imageUrl='baseConfig.title.textRgb' 
                @getImageData="(val)=>{return getImageData(val,'textRgb')}" 
                @delImageData="delImageData('textRgb')" urlName="textRgb">
              </avatarUpload>
            </p>
          </div>
    </div>
</template>

<script>
import { getCurrentInstance,ref,onMounted,onUnmounted,watch,shallowRef,computed } from "vue";
import * as echarts from 'echarts';
import { useStore } from 'vuex';
import { colorCustomMerge, cloneDeep  } from '../../../utils'// 
import { ElMessage, ElMessageBox } from 'element-plus'
import avatarUpload from './avatarUpload'

// import sj from './components/json/sj.json'
export default {
    components: {avatarUpload },
    props: {
        baseConfig: {
            type: Object,
            default: function () { return {} }
        },
        // yearRef:{
        //     type: String,
        //     default: function () { return "2024" }
        // }
    },
    setup(props,ctx) {
        const { proxy } = getCurrentInstance();
        const option = ref({})
        const barChartRef = shallowRef(null);
        const chartInstance = shallowRef(null);
        const optionxy=ref([{name:'居中',value:'center'},{name:'左对齐',value:'left'},{name:'右对齐',value:'right'}])
        const store = useStore();
        // title:{
        //                 textShow:true,
        //                 textTitle:'',
        //                 textColor:'',
        //                 textSzie:'',
        //                 textAlign:'',
        //                 textIcon:'',
        //                 textRgb:'',
        //             }
        const baseConfig=ref(props.baseConfig)
        baseConfig.value.title = baseConfig.value.title||{}
            function getImageData(val,type){
                if(type=='textIcon'){
                    baseConfig.value.title.textIcon=val
                }else{
                    baseConfig.value.title.textRgb=val
                }
                ctx.emit('handleclickTitle',baseConfig.value)
        }
        function delImageData(type){
            if(type=='textIcon'){
                    baseConfig.value.title.textIcon=''
                }else{
                    baseConfig.value.title.textRgb=''
                }
                ctx.emit('handleclickTitle',baseConfig.value)
        }
       const handleclickblur = (e)=>{
        ctx.emit('handleclickTitle',baseConfig.value)
       }
        return{
            optionxy,
            baseConfig,
            getImageData,
            delImageData,
            handleclickblur
        }
    }
}
</script>

<style scoped lang="less">
.titleText {
    max-height: 400px;
    overflow: auto;
    .setvalue {
     .el-input-number{
         width: 210px;
        //  height: 23px;
     }
     .el-select{
        width: 210px;
     }
     .el-input{
        width: 210px;
     }
  }
}

</style>